const faq = () => {
  var faqTitle = document.querySelectorAll('.p-recruitment__faq dl dt');
  if(faqTitle != null) {
    faqTitle.forEach(function(dt) {
      dt.addEventListener('click', function() {
          // Toggle 'is-show' class
          this.classList.toggle('is-show');

          // Next element therefore assuming it's the dd following dt
          var dd = this.nextElementSibling;

          // Check if it is visible
          if (dd.style.display === 'block') {
              dd.style.display = 'none';
          } else {
              dd.style.display = 'block';
              // Animation for slideToggle effect
              dd.style.transition = 'max-height 0.3s ease-in-out';
              dd.style.overflow = 'hidden';
              dd.style.maxHeight = dd.scrollHeight + 'px';
          }

          // Optional: smoothly collapse the expanded area.
          setTimeout(() => {
              if(dd.style.display === 'block') {
                  dd.style.maxHeight = null;
              }
          }, 300); // match the 300ms animation

          // Prevent default
          return false;
      });
    });
  }
};
